import { Link } from "react-router-dom";
import { ArrowLeft, Shield } from "lucide-react";

export default function FormShell({ title, subtitle, step, totalSteps, children }) {
  const progress = ((step + 1) / totalSteps) * 100;
  return (
    <div className="min-h-screen bg-bone">
      <header className="border-b border-line bg-bone sticky top-0 z-30">
        <div className="max-w-5xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="back-to-home-link">
            <div className="w-8 h-8 bg-forest rounded-sm flex items-center justify-center">
              <Shield className="w-4 h-4 text-bone" strokeWidth={2} />
            </div>
            <span className="font-heading font-medium text-lg tracking-tight">InsureWell</span>
          </Link>
          <Link to="/" className="text-sm text-sage hover:text-forest flex items-center gap-1 transition-colors duration-200">
            <ArrowLeft className="w-4 h-4" /> Cancel
          </Link>
        </div>
        <div className="h-1 bg-stone">
          <div
            className="h-full bg-clay transition-[width] duration-500"
            style={{ width: `${progress}%` }}
            data-testid="form-progress-bar"
          />
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 lg:px-10 py-12 md:py-16">
        <div className="text-xs uppercase tracking-[0.2em] text-clay font-semibold mb-3">
          Step {step + 1} of {totalSteps}
        </div>
        <h1 className="font-heading text-3xl md:text-4xl tracking-tight font-medium mb-2">{title}</h1>
        {subtitle && <p className="text-sage text-base leading-relaxed mb-10">{subtitle}</p>}
        <div className="bg-white border border-line rounded-sm p-6 md:p-10">{children}</div>
      </main>
    </div>
  );
}
